export const REQUEST_APPROVE_TAB = {
    LEAVE: "PendingApprovalLeaveTable",
    OFFSITEWORK: "PendingApprovalOffsiteWorkTable",
    REDEEMTIME: "PendingApprovalRedeemTimeTable",
    ENDORSETIME: "PendingApprovalEndorseTimeTable",
    OVERTIME: "PendingApprovalOvertimeTable",
    COLLECTTIME: "PendingApprovalCollectTimeTable",
    EXPENSE: "PendingApprovalExpenseTable",
    REQUESTFORM: "RequestForm",
    CHANGESHIFT: "ChangeShift",
    MOVEMENT: "Movement",
    WARNING_LETTER: "WarningLetter",
}